import React from 'react';

import { ContactActionsLayout } from '../../../../components/ContactActionsLayout';
import { useOfferContext } from '../../../../context';
import { getIsDailyRent } from '../../../../utils/computedProps/price/rent/getIsDailyRent';
import { AgentPhoneButtonContainer } from '../AgentPhoneButtonContainer';
import { AgentShowMoreOffersContainer } from '../AgentShowMoreOffersContainer';
import { ChatButtonContainer } from '../ChatButtonContainer';
import { DailyrentActionButtonsContainer } from '../DailyrentActionButtonsContainer';
import { JoinElectronicTradingButtonContainer } from '../JoinElectronicTradingButtonContainer';

export const ContactActionsContainer = () => {
  const offerData = useOfferContext();
  const {
    offer: { category },
  } = offerData;

  const isDailyrent = getIsDailyRent(category);

  if (isDailyrent) {
    return <DailyrentActionButtonsContainer />;
  }

  return (
    <ContactActionsLayout
      showMoreOffersLink={<AgentShowMoreOffersContainer />}
      chatButton={<ChatButtonContainer />}
      phoneButton={<AgentPhoneButtonContainer />}
      electronicTradingButton={<JoinElectronicTradingButtonContainer />}
    />
  );
};
